<template>
  <el-row class="header">
    <el-col :span="4">
      <er-single-day-picker
        :value="selectedDate"
        value-format="yyyy-MM-dd"
        :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
        @change-prev-day="prevDayClick"
        @change-next-day="nextDayClick"
        @change-day="handlePresentDateChange"
      ></er-single-day-picker>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: function() {
    return {
      searchString: "",
      selectedDate: ""
    };
  },
  created() {
    this.selectedDate = this.$moment()
      .utcOffset(this.getUserTimeZoneOffset)
      .startOf("day")
      .format("YYYY-MM-DD");

    // this.$store.registerModule("medicines", medicinesMod);
    this.changeDate(this.selectedDate);
  },
  computed: {
    ...mapGetters("user", {
      getUserTimeZoneOffset: "getUserTimeZoneOffset",
      isReadOnly: "isReadOnly"
    }),
    dialogVisibleStatus: {
      get() {
        return this.getStateOfDialogBox;
      },
      set(value) {
        this.changeDialogBoxVisibleStatus(value);
      }
    }
  },
  methods: {
    ...mapActions("labTests", {
      changeDate: "changeDate"
    }),
    async prevDayClick(date) {
      // await this.$emit("reload");
      this.selectedDate = date;
      this.changeDate(date);
    },
    async nextDayClick(date) {
      // await this.$emit("reload");
      this.selectedDate = date;
      this.changeDate(date);
    },
    async handlePresentDateChange(date) {
      console.log("date changed");
      // await this.$emit("reload");
      this.selectedDate = date;

      this.changeDate(date);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-end;
}
</style>
